const elmSwiper = document.querySelectorAll('.mySwiperSchool');
const buttonPrev = document.querySelectorAll('.swiper-button-prev');
const buttonNext = document.querySelectorAll('.swiper-button-next');

if (elmSwiper.length > 0) {
  for (let i = 0; i < elmSwiper.length; i++) {
    elmSwiper[i].className += i;
    buttonPrev[i].className += i;
    buttonNext[i].className += i;

    const swiper = new Swiper('.mySwiperSchool' + i, {
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 5,
        },
      },
      spaceBetween: 20,
      direction: 'horizontal',
      loop: true, //最後に達したら先頭に戻る
      slidesPerView: 'auto', //何枚表示するか
      spaceBetween: 15,
      speed: 1200, // スライドアニメーションのスピード（ミリ秒）
      autoplay: {
        //自動再生する
        delay: 500, //次のスライドに切り替わるまでの時間
        waitForTransition: true, // アニメーションの間にスライドを止めるか
      },
      //ナビゲーションボタン（矢印）表示の設定
      navigation: {
        nextEl: '.swiper-button-next' + i, //「次へボタン」要素のクラス名
        prevEl: '.swiper-button-prev' + i, //「前へボタン」要素のクラス名
      },
    });
  }
}

// CookieにSchoolIDをセット（お問い合わせ用）
const elementWithSchoolId = document.querySelector('[data-schoolid]');
const schoolId = elementWithSchoolId.getAttribute('data-schoolid');
document.cookie = 'schoolid=' + schoolId +'; Path=/; Max-Age=86400; Secure';